export default {
  storeTaskList(state, tasks) {
    state.tasks = tasks;
  },
  storeTask(state, task) {
    state.task = task;
  },
  storeUpdatedTask(state, updatedTask) {
    const foundIndex = state.tasks.findIndex(x => x.id === updatedTask.id);
    state.tasks[foundIndex] = updatedTask;
  },
  storeCreatedTask(state, createdTask) {
    state.tasks = state.tasks.concat(createdTask);
  },
  appendMessage(state, params) {
    const foundIndex = state.tasks.findIndex(x => x.id === params.id);
    const messages = state.tasks[foundIndex].task_messages;
    state.tasks[foundIndex].task_messages = messages.concat(params.task_message);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tasks/mutations.js